import { ga } from 'js/analytics/adapters'

export const trackChooseLoginMethod = ({ method: login_method }) => {
  ga.track('choose_login_method', { login_method })
}
